module.exports = __webpack_public_path__ + "img/绍兴市.95608104.png";